import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { PlayerIcon } from '@/enums/player-icon';

import VideoPlayerWrapper from './VideoPlayerWrapper.vue';
import { useMounted } from '@vueuse/core';
import { TrailerClip } from '@/interfaces/trailerClip';
import { isJustWatchTVPlayBtnLanguageSupported } from '@/helpers/justwatchTv-helper';
import { useLanguageStore } from '@/helpers/composables/useStores';
import { Clip } from '@/@types/graphql-types';

interface DailyMotionPlayerProps {
	clip: TrailerClip | Clip;
	isActive?: boolean;
	isBackdrop?: boolean;
	playIconType?: PlayerIcon | null;
	isDisneyPlusOffer?: boolean;
	isTitleTrailer?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DailyMotionPlayer',
  props: {
    clip: null,
    isActive: { type: Boolean, default: false },
    isBackdrop: { type: Boolean, default: false },
    playIconType: { default: null },
    isDisneyPlusOffer: { type: Boolean, default: false },
    isTitleTrailer: { type: Boolean }
  },
  emits: ["setActiveClipId", "onPlaying"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'setActiveClipId', clipId: string): void;
	(e: 'onPlaying', clip: DailyMotionPlayerProps['clip']): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { clip: TrailerClip | Clip, isActive: boolean, isBackdrop: boolean, playIconType: PlayerIcon | null, isDisneyPlusOffer: boolean, isTitleTrailer?: boolean };

const JustWatchTVPlayBtn = () => import('@/pages/titleDetailV1/v1/hero/JustwatchTVPlayBtn.vue');

const isMounted = useMounted();
const { language } = useLanguageStore();





const srcUrl = computed(() => {
	if (props.clip.sourceUrl) return props.clip.sourceUrl;

	return `https://geo.dailymotion.com/player/${isJustWatchTV.value ? 'x10mxm' : 'xb9cu'}.html?video= ${
		props.clip.externalId
	}`;
});

const isJustWatchTV = computed(() => props.clip.provider === 'JUSTWATCH_TV');

function play() {
	emit('setActiveClipId', props.clip.externalId);

	// onPlaying triggers scrolling to active clip. setTimeout prevents onPlaying triggering scroll events before activeClip is updated
	setTimeout(() => {
		emit('onPlaying', props.clip);
	}, 200);
}

return { __sfc: true,JustWatchTVPlayBtn, isMounted, language, props, emit, srcUrl, isJustWatchTV, play, VideoPlayerWrapper, isJustWatchTVPlayBtnLanguageSupported }
}

})